import { combineReducers } from "redux";
import errorReducer from "./errorReducer";
import loaderReducer from "./loaderReducer";
import languageReducer from "./languageReducer";
import userProfileReducer from "./userProfileReducer";
import tokenReducer from "./tokenReducer";
import dashboardReducer from "./dashboardReducer";
import featureflightReducer from "./featureflightReducer";
import { sessionReducer }  from 'redux-react-session';

const rootReducer = combineReducers({
    lang: languageReducer,
    userProfile: userProfileReducer,
    err:errorReducer,
    dashboard:dashboardReducer,
    token:tokenReducer,
    featureflight:featureflightReducer,
    session: sessionReducer,
    loader:loaderReducer
})
export default rootReducer;